import React from 'react'
declare const I18n;

type Props = {
  title?: string;
  value?: number;
  total?: number;
  card?: boolean;
  displayStep?: booean;
}


const ProgressBar: React.FC<Props> = ({ title, value, total, card, displayStep=true }) => {
  if (!value) return null;

  if (!value) {
    return null;
  }

  if (card) {
    return (
      <div className="progress-container-card">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "0.9rem",
            color: "black"
          }}
        >
          {
            (total) &&
            <div style={{ display: "flex"}}>
              <span className="fw-bold">{title}</span>
              <span
                dangerouslySetInnerHTML={{
                  __html: I18n.t('views.common.progress_bar_card', {
                    current: value <= total ? value : value - 1,
                    total,
                  }),
                }}
              />
            </div>
          }
          <span>
            <strong>
              <span>{Math.floor((value / total) * 100)}%</span>
            </strong>
          </span>
        </div>
        <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow={value} aria-valuemin={0} aria-valuemax={100}>
          <div className="progress-bar" style={{ width: `${value / total * 100}%` }}></div>
        </div>
      </div>
    )
  }

  return (
    <div className="progress-container">
      <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow={value} aria-valuemin={0} aria-valuemax={100}>
        <div className="progress-bar" style={{ width: `${value / total * 100}%` }}></div>
      </div>
      {
        (title || total) &&
        <div style={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
          <span className="fw-bold">{title}</span>
          {displayStep ? <span>{I18n.t('views.common.progress_bar', { current: value <= total ? value : value - 1, total: total })}</span> : null}
        </div>
      }
    </div>
  )
}

export default ProgressBar